import React from "react";
import { Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";

function ContactComponent() {
  const contactItems = [
    {
      icon: "fa-phone",
      label: "Call Us",
      value: "+91 87775 04946",
      href: "tel:+918777504946",
    },
    {
      icon: "fa-envelope",
      label: "Email Us",
      value: "contact@gowave.in",
      href: "mailto:contact@gowave.in",
    },
    {
      icon: "fa-map-marker",
      label: "Visit Us",
      value: "Kolkata, India",
      href: null,
    },
  ];

  return (
    <div className="contact-section-new" id="contact">
      <div className="container">
        <Row className="contact-row-new">
          {contactItems.map((item, i) => (
            <Col xs={12} md={4} key={item.icon}>
              <motion.div
                className="contact-card-new"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.15 }}
              >
                <div className="contact-icon-wrap">
                  <span className={`fa ${item.icon}`}></span>
                </div>
                <div className="contact-info-new">
                  <span className="contact-label-new">{item.label}</span>
                  {item.href ? (
                    <a href={item.href} className="contact-value-new">
                      {item.value}
                    </a>
                  ) : (
                    <span className="contact-value-new">{item.value}</span>
                  )}
                </div>
              </motion.div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}

export default ContactComponent;
